import { FORTUNE_WHEEL_PRIZE_ID } from '@/types/shared/fortune-wheel'

export type ExtraSpinCounts = {
  referral: number,
  upgrades: number,
  levelUp: number,
  ad: {
    spinCount: number,
    perDayCount: number
  }
}

export enum FORTUNE_WHEEL_REWARD {
  POINT1 = 'point1',
  POINT2 = 'point2',
  POINT3 = 'point3',
  POINT4 = 'point4',
  SPIN1 = 'spin1',
  SPIN_GOLDEN1 = 'spin_golden1',
  USDT5 = 'usdt5',
  USDT10 = 'usdt10',
  USDT50 = 'usdt50',
  USDT100 = 'usdt100',
  USDT500 = 'usdt500',
  GOLDEN_USDT25 = 'golden_usdt25',
  GOLDEN_USDT50 = 'golden_usdt50',
  GOLDEN_USDT100 = 'golden_usdt100',
  GOLDEN_USDT500 = 'golden_usdt500',
  GOLDEN_USDT1000 = 'golden_usdt1000',
  GOLDEN_USDT2000 = 'golden_usdt2000',
  GOLDEN_USDT5000 = 'golden_usdt5000',
  GOLDEN_SPIN5 = 'golden_spin5',
  GOLDEN_SPIN10 = 'golden_spin10',
  GOLDEN_SPIN25 = 'golden_spin25',
  GOLDEN_SPIN50 = 'golden_spin50',
  CHEST = 'chest',
  TICKET = 'ticket',
  GOLD_FEATHER_10 = 'gold_feather_10',
}

export const fortuneWheelPrizes: Record<FORTUNE_WHEEL_REWARD, FORTUNE_WHEEL_PRIZE_ID[]> = {
  [FORTUNE_WHEEL_REWARD.POINT1]: [FORTUNE_WHEEL_PRIZE_ID.POINT1],
  [FORTUNE_WHEEL_REWARD.POINT2]: [FORTUNE_WHEEL_PRIZE_ID.POINT2],
  [FORTUNE_WHEEL_REWARD.POINT3]: [FORTUNE_WHEEL_PRIZE_ID.POINT3],
  [FORTUNE_WHEEL_REWARD.POINT4]: [FORTUNE_WHEEL_PRIZE_ID.POINT4],

  [FORTUNE_WHEEL_REWARD.SPIN1]: [FORTUNE_WHEEL_PRIZE_ID.SPIN1],
  [FORTUNE_WHEEL_REWARD.SPIN_GOLDEN1]: [FORTUNE_WHEEL_PRIZE_ID.SPIN_GOLDEN1],

  [FORTUNE_WHEEL_REWARD.USDT5]: [FORTUNE_WHEEL_PRIZE_ID.USDT5],
  [FORTUNE_WHEEL_REWARD.USDT10]: [FORTUNE_WHEEL_PRIZE_ID.USDT10],
  [FORTUNE_WHEEL_REWARD.USDT50]: [FORTUNE_WHEEL_PRIZE_ID.USDT50],
  [FORTUNE_WHEEL_REWARD.USDT100]: [FORTUNE_WHEEL_PRIZE_ID.USDT100],
  [FORTUNE_WHEEL_REWARD.USDT500]: [FORTUNE_WHEEL_PRIZE_ID.USDT500],

  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT25]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT25],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT50]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT50],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT100]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT100],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT500]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT500],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT1000]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT1000],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT2000]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT2000],
  [FORTUNE_WHEEL_REWARD.GOLDEN_USDT5000]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_USDT5000],

  [FORTUNE_WHEEL_REWARD.GOLDEN_SPIN5]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_SPIN5],
  [FORTUNE_WHEEL_REWARD.GOLDEN_SPIN10]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_SPIN10],
  [FORTUNE_WHEEL_REWARD.GOLDEN_SPIN25]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_SPIN25],
  [FORTUNE_WHEEL_REWARD.GOLDEN_SPIN50]: [FORTUNE_WHEEL_PRIZE_ID.GOLDEN_SPIN50],

  [FORTUNE_WHEEL_REWARD.CHEST]: [
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_DOUBLE_PROFIT_0_5,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_DOUBLE_PROFIT_3,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_OFFLINE_PROFIT_0_5,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_OFFLINE_PROFIT_1,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_OFFLINE_PROFIT_2,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_GOLDEN_COIN_1,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_GOLDEN_COIN_3,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_SPIN_3,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_SPIN_5,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_SPIN_10,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_TICKET_1,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_GOLD_FEATHER_50,
    FORTUNE_WHEEL_PRIZE_ID.PRIZE_BOX_GOLD_FEATHER_100,
  ],
  [FORTUNE_WHEEL_REWARD.TICKET]: [FORTUNE_WHEEL_PRIZE_ID.TICKET],
  [FORTUNE_WHEEL_REWARD.GOLD_FEATHER_10]: [FORTUNE_WHEEL_PRIZE_ID.GOLD_FEATHER_10],
}

export const fortuneWheelRewards: FORTUNE_WHEEL_REWARD[] = [
  FORTUNE_WHEEL_REWARD.TICKET,
  FORTUNE_WHEEL_REWARD.POINT1,
  FORTUNE_WHEEL_REWARD.USDT10,
  FORTUNE_WHEEL_REWARD.GOLD_FEATHER_10,
  FORTUNE_WHEEL_REWARD.SPIN_GOLDEN1,
  FORTUNE_WHEEL_REWARD.CHEST,
  FORTUNE_WHEEL_REWARD.USDT100,
  FORTUNE_WHEEL_REWARD.POINT3,
  FORTUNE_WHEEL_REWARD.USDT5,
  FORTUNE_WHEEL_REWARD.POINT4,
]

export const goldenWheelRewards: FORTUNE_WHEEL_REWARD[] = [
  FORTUNE_WHEEL_REWARD.GOLDEN_SPIN50,
  FORTUNE_WHEEL_REWARD.GOLDEN_USDT500,
  FORTUNE_WHEEL_REWARD.GOLDEN_SPIN10,
  FORTUNE_WHEEL_REWARD.GOLDEN_USDT25,
  FORTUNE_WHEEL_REWARD.GOLDEN_SPIN5,
  FORTUNE_WHEEL_REWARD.GOLDEN_USDT50,
  FORTUNE_WHEEL_REWARD.GOLDEN_SPIN25,
  FORTUNE_WHEEL_REWARD.GOLDEN_USDT25,
  FORTUNE_WHEEL_REWARD.GOLDEN_SPIN5,
  FORTUNE_WHEEL_REWARD.GOLDEN_USDT100,
]
